import { Flex, Skeleton } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

import { useHospitalRegistrationProgress } from "./useHospitalRegistrationProgress";

export const RegistrationHospitalContinue = () => {
  const history = useHistory();
  const progress = useHospitalRegistrationProgress();
  if (progress !== "Loading") {
    history.push(progress);
  }

  return (
    <Flex className="p-5">
      <Skeleton active />
    </Flex>
  );
};
